<template>
  <div>
    <Row style="margin: 10px">
      <Col class="filter-col search-box">
        <Input
          v-model="keyword" placeholder="案件编号/案号/对方当事人/经营者/法人/店铺名称"
          style="width: 350px;"
          @on-enter="reloadTable"
        >
          <Icon
            slot="suffix" type="ios-search"
            @click="reloadTable"
          />
        </Input>
        <span style="margin-left: 20px;color: #f4aa48;">请点击勾选案件申请材料</span>
      </Col>
    </Row>
    <Table
      ref="checkboxTable" :columns="columns"
      :data="tableData" :loading="tableLoading"
    />
    <!-- 分页 -->
    <Row style="margin-top:30px;text-align:center;">
      <Page
        :total="table.totalRecords" show-total
        size="small"
        :current="table.pageNum"
        :page-size-opts="config.modalPageSizeOpts"
        :page-size="table.pageSize"
        prev-text="上一页" next-text="下一页"
        show-sizer
        show-elevator
        @on-change="changePage" @on-page-size-change="changeSize"
      />
    </Row>
    <!-- 案件详情 -->
    <Drawer
      v-model="caseInfoCtrl"
      width="1200"
      :styles="{padding:'0px'}"
      :mask-style="{background:'rgba(0,0,0,0)'}"
      @on-close="closeDetail"
    >
      <div slot="header" class="drawer-title">案件详情</div>
      <case-detail
        v-if="caseInfoCtrl" style="top:0;"
        :case-detail="caseDetail"
      />
    </Drawer>
  </div>
</template>

<script>
import styles from '@/assets/globalStyle.scss'
import CaseDetail from '@/view/case/caseDetail.vue'

export default {
  name: 'SelectCase',
  components: {
    CaseDetail
  },
  data() {
    return {
      columns: [
        {
          title: '选择',
          key: 'caseId',
          fixed: 'left',
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Checkbox', {
                props: {
                  value: params.row.checkBox
                },
                on: {
                  'on-change': (e) => {
                    this.tableData.forEach((items) => { // 先取消所有对象的勾选，checkBox设置为false
                      this.$set(items, 'checkBox', false)
                    })
                    this.tableData[params.index].checkBox = e // 再将勾选的对象的checkBox设置为true
                    // this.selectedCaseId = this.tableData[params.index] && this.tableData[params.index].caseId
                    this.selectedRow = this.tableData[params.index]
                    if (!e) this.selectedRow = null
                    this.$emit('selectCase', this.selectedRow)
                  }
                }
              })
            ])
          }
        },
        {
          title: '案件编号',
          key: 'caseCode',
          minWidth: 120,
          render: (h, { row }) => {
            const dom = h('a', {
              class: {
                'textover': true,
                'table-sub-style': true
                // 'has-sub-project':params.row.hasSubCase
              },
              style: {
                color: styles.globalMainColor
              },
              attrs: {
                title: row.caseCode
              },
              on: {
                'click': () => {
                  console.log('row', row)
                  this.getCaseDetail(row.caseId)
                }
              }
            }, row.caseCode)
            return dom
          }
        },
        {
          title: '对方当事人',
          key: 'litigantList',
          minWidth: 160,
          render: (h, { row }) => {
            const domArr = []
            row.litigantList && row.litigantList.forEach((item, index) => {
              const iconDom = h('span', {
                class: 'descripe-icon',
                style: {
                  'marginRight': '5px'
                }
              }, item.type === 'M' ? '生' : '销')
              const spanDom = h('span', item.name)
              const pDom = h('p', {
                class: 'textover',
                attrs: { title: item.name },
                style: {
                  'marginBottom': index != row.litigantList.length - 1 ? '5px' : '0'
                }
              }, [iconDom, spanDom])
              domArr.push(pDom)
            })
            return h('div', {
              style: {
                'padding': row.litigantList.length > 1 ? '5px 0' : '0'
              }
            }, domArr)
          }
        },
        {
          title: '案件区域',
          key: 'cityName',
          render: (h, params) => {
            return h('span', {
              class: 'textover',
              attrs: {
                title: (params.row.provinceName || '') + (params.row.cityName || '') + (params.row.areaName || '')
              }
            },
            (params.row.provinceName || '') + (params.row.cityName || '') + (params.row.areaName || ''))
          }
        },
        {
          title: '判决日期',
          key: 'judgementDate',
          width: 130,
          render: (h, { row }) => {
            const color = row.warningFlag ? 'red' : '#515a6e'
            return h('span', {
              class: 'textover',
              attrs: {
                title: row.judgementDate
              },
              style: {
                color: color
              }

            }, this.common.formatTime(row.judgementDate, 1))
          }
        },
        {
          title: '所属项目',
          key: 'projectName',
          render: (h, params) => {
            return h('span', {
              class: 'textover',
              attrs: {
                title: params.row.projectName
              }
            }, params.row.projectName)
          }
        }
      ],
      tableLoading: false,
      caseInfoCtrl: false,
      keyword: null,
      selectedCaseId: null,
      selectedRow: null,
      tableData: [],
      caseDetail: {},
      table: { // 表格数据接口的相关参数
        pageSize: 5,
        pageNum: 1,
        totalRecords: 1
      }
    }
  },
  methods: {
    closeDetail() {
      this.getData()
    },
    // 获取案件详情
    getCaseDetail(id) {
      const url = '/business/case/' + id + '/lawyer'
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.caseDetail = res.data
          this.caseInfoCtrl = true
        }
      })
    },
    changePage(page) {
      this.table.pageNum = page
      this.getData()
    },
    changeSize(size) {
      this.table.pageSize = size
      this.getData()
    },
    // 重载table
    reloadTable(rePage) {
      if (rePage) this.table.pageNum = 1
      this.getData()
    },
    getData() {
      const ajaxData = {
        current: this.table.pageNum,
        size: this.table.pageSize,
        keyword: this.keyword
      }
      this.tableLoading = true
      this.$get('/business/case/judgment/material/page-other', ajaxData).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          this.tableData = res.data.records
          this.table.totalRecords = res.data.total
          // this.$refs.checkboxTable.clearSelected()
        }
      })
    },
    onChange(valList) {
      console.log(valList)
      this.formValidate.financeSeal = valList.includes('财务章')
      this.formValidate.custSeal = valList.includes('公章')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/carryoutMaterialManage/components/selectCase.vue